// @flow
import styled from "styled-components"
import { Text } from "componentsStyled/Typography/Texts"

export const MobileHeaderWrap = styled.header`
  position: fixed;
  width: 100%;
  z-index: ${(props) => props.theme.zIndices.header};
`

export const HeaderInner = styled.div`
  height: 6.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const PageInner = styled.div`
  padding-top: 1.6rem;
`

export const StyledText = styled(Text)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const Wrap = styled.div`
  width: ${props => props.width || "100%"};
`

export const FooterWrap = styled.footer`
`


// WEBPACK FOOTER //
// ./src/pages/_Page/SubPage/styled.js